import type { TenantThemeDefinition } from "../../core/types.ts";
import { zuuTenantApps } from "./apps.ts";
import { zuuTenantBase } from "./base.ts";

export const zuuTenantTheme = {
  id: "zuu",
  brandId: "zuu",
  label: "ZUU",
  description: "ZUU 使用的海军蓝与金色基础风格预设。",
  base: zuuTenantBase,
  apps: zuuTenantApps,
} satisfies TenantThemeDefinition;

